import { brandConfig } from '../config.js';

export function initFeatures() {
  const features = brandConfig.features || {};
  document.querySelectorAll('[data-feature]').forEach(el => {
    const key = el.dataset.feature;
    if (Object.prototype.hasOwnProperty.call(features, key) && features[key] === false) {
      el.hidden = true;
    }
  });
}
